import { Form2 } from "@cd2/forms"

export function Form2ValidatePostcodeLength({ field }: { field: string }) {
  Form2.useFormSubmitLock(formState => {
    const formField = formState.getField(field)
    if (formField.getValue() && formField.getValue().length > 10) {
      formField.setError("must be 10 or less characters.")
      return false
    } else {
      formField.setError(undefined)
    }
  })

  return null
}
